// Libraries
var React = require('react');

// Components
var OptaWidget = require('../OptaWidget/OptaWidget');

// Styles
require('./MatchGoalReplay.scss');

class MatchGoalReplayModule extends React.Component {
    
	render() {
        return (
            <div className="MatchGoalReplay">
                <h2>Goal Replay</h2>
                <OptaWidget language={this.props.data.language} timezone={this.props.data.timezone} subscriptionId={this.props.data.subscriptionId} properties={this.props.data.properties}/>
            </div>)
    }
}
    
module.exports = MatchGoalReplayModule;


// WEBPACK FOOTER //
// ./src/components/MDC/MatchGoalReplay/MatchGoalReplayModule.js